/* eslint-disable @typescript-eslint/no-empty-object-type */

import type { L as TL, O as TO } from 'ts-toolbelt'

import { baseRequestClient } from '../request'

type HTTP = typeof baseRequestClient

function processPath(pathTemplate: string, data: Recordable = {}) {
  data = {
    ...data,
  }
  const path = pathTemplate.replaceAll(/\{(\w+)\}/g, (_, key) => {
    const value = data[key]
    delete data[key]
    return value
  })
  return {
    url: path,
    data,
  }
}

type Params<
  Obj extends undefined | unknown | {},
  Sources extends unknown[],
> = TO.MergeAll<
  Obj extends {} ? Obj : {},
  TL.Pick<Sources, TL.NonNullableKeys<Sources>>
>

export type FixPagingRes<T> = T extends { limit?: any }
  ? T
  : T extends { list: any }
    ? T['list']
    : T

function fixUrl(url: string) {
  if (url.startsWith('/')) {
    return url.slice(1)
  }
  return url
}

export function GET<const T extends SwaggerAuth.PathsWithMethod<'get'>>(
  path: T,
  params?: Params<
    SwaggerAuth.GetPath<T>['get'],
    [SwaggerAuth.GetQuery<T>['get']]
  >,
  options?: Parameters<HTTP['get']>[1],
): Promise<FixPagingRes<SwaggerAuth.GetRes<T>['get']['data']>> {
  const { url, data } = processPath(path, params)
  return baseRequestClient.get(`auth/${fixUrl(url)}`, {
    params: data,
    ...options,
  })
}

export function POST<const T extends SwaggerAuth.PathsWithMethod<'post'>>(
  path: T,
  params?: Params<
    SwaggerAuth.GetPath<T>['post'],
    [SwaggerAuth.GetBody<T>['post']]
  >,
  options?: Parameters<HTTP['post']>[2],
): Promise<FixPagingRes<SwaggerAuth.GetRes<T>['post']['data']>> {
  const { url, data } = processPath(path, params)
  return baseRequestClient.post(`auth/${fixUrl(url)}`, data, options) as any
}

export const swaggerAuthClient = {
  get: GET,
  post: POST,
}
